module.exports = __webpack_public_path__ + "static/media/geojsonFormat.5ed3823a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/geojsonFormat.jpg
// module id = 838
// module chunks = 0